import { render, staticRenderFns } from "./fireFightingHistory.vue?vue&type=template&id=31d67d22"
import script from "./fireFightingHistory.vue?vue&type=script&lang=js"
export * from "./fireFightingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d67d22')) {
      api.createRecord('31d67d22', component.options)
    } else {
      api.reload('31d67d22', component.options)
    }
    module.hot.accept("./fireFightingHistory.vue?vue&type=template&id=31d67d22", function () {
      api.rerender('31d67d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/fft/fireFightingHistory.vue"
export default component.exports